import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommunityFocus } from 'src/app/swagger-api';
import { SocialInitiativeChange } from '../../shared/social-initiative/social-initiative-change.abstract';
import { CommunityView } from '../communities-store';
import { FieldState } from '../community-form-state';
import { CommunityFormData } from '../create-community.interfaces';

@Component({
  selector: 'app-update-community',
  templateUrl: './update-community.component.html',
  styleUrls: ['./update-community.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateCommunityComponent extends SocialInitiativeChange<CommunityFormData> implements AfterViewInit {
  @Input({ required: true }) public community: CommunityView;
  @Input({ required: true }) public focusState: FieldState<CommunityFocus>;

  @Output() public canceled: EventEmitter<void> = new EventEmitter<void>();
  @Output() public removeCommunity: EventEmitter<void> = new EventEmitter<void>();
  @Output() public updateCommunity: EventEmitter<CommunityFormData> = new EventEmitter<CommunityFormData>();

  public ngAfterViewInit(): void {
    this.subscribeToControlValueChanges();
  }

  public onCancel(): void {
    this.canceled.emit();
  }

  public onRemoveCommunity(): void {
    this.removeCommunity.emit();
  }

  protected changeEntity(data: CommunityFormData): void {
    this.updateCommunity.emit(data);
  }
}
